var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LibQrCode"},[_c('img',{style:({
      width: _vm.size,
      height: _vm.size,
    }),attrs:{"src":_vm.imgUrl}}),_c(_vm.vueQr,{tag:"component",attrs:{"logoSrc":_vm.icon,"callback":_vm.test,"text":_vm.text,"size":1000,"bindElement":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }